module.exports = __webpack_public_path__ + "static/media/logo-sm-dark.64a02162.png";